module.exports = __webpack_public_path__ + "img/BNB.78b90c64.jpeg";